import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import { fetchServiceHistoryBrands } from "../pre-delivery-inspection/actions";
import { setManualLead } from "../car-service-history-info/actions";

const mapStateToProps = ({
    brands: { all: brands },
    carServiceHistoryInfo: { manualLead: brand } }) => {
    return {
        brands,
        brand
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        fetchBrandsConnect: fetchServiceHistoryBrands,
        setDetailsConnect: setManualLead
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
